import { useState } from 'react';

import { TraceBoardColumn } from '../interfaces/TraceBoardColumn';

export function useRowCollapse(columns: TraceBoardColumn[]) {
  const [rowCollapse, setRowCollapse] = useState<boolean[]>([]);
  const toggleCollapseRow = (index?: number) => {
    const column = columns[0];
    if (!column) return;
    if (typeof index === 'undefined') {
      if (rowCollapse.length === 0 || rowCollapse.some(r => !r)) {
        // collpase all and account for orphaned row
        setRowCollapse([...column.items.map(_ => true), true]);
      } else {
        // expand all and account for orphaned row
        setRowCollapse([...column.items.map(_ => false), false]);
      }
    } else {
      rowCollapse[index] = !rowCollapse[index];
      setRowCollapse([...rowCollapse]);
    }
  };
  return { rowCollapse, toggleCollapseRow };
}
